import { useNavigate } from "react-router-dom";
import { ExternalLink } from "lucide-react";
import { Sheet, SheetContent, SheetTitle, SheetDescription } from "@/components/ui/sheet";
import { Button } from "@/components/ui/button";
import { EntityDetail } from "@/components/EntityDetail";

export const EntityPanel = ({ entityId, onClose, onNavigate, base }) => {
  const navigate = useNavigate();
  return (
    <Sheet open={!!entityId} onOpenChange={(o) => !o && onClose()}>
      <SheetContent side="right" className="w-full sm:w-[440px] sm:max-w-[440px] bg-[#13171F] border-l border-[#2D3442] p-0 overflow-y-auto lf-scroll" data-testid="entity-panel">
        <SheetTitle className="sr-only">Entry details</SheetTitle>
        <SheetDescription className="sr-only">Lore entry side panel</SheetDescription>
        <div className="p-7">
          <Button variant="ghost" size="sm" className="mb-4 -ml-2 text-[#A8A090]" data-testid="entity-panel-open-full"
            onClick={() => { navigate(`${base}/lore/${entityId}`); onClose(); }}>
            <ExternalLink className="h-3.5 w-3.5 mr-1.5" />Open full page
          </Button>
          {entityId && <EntityDetail entityId={entityId} onNavigate={onNavigate} compact onDeleted={onClose} />}
        </div>
      </SheetContent>
    </Sheet>
  );
};
